import React from 'react'
import { Typography } from 'antd'
import AppConfigurationSettings from '../components/AppConfigurationSettings'

const { Title } = Typography

const AppConfigurationPage: React.FC = () => {
  return (
    <div className="min-h-screen">
        {/* Header */}
        <div className="mb-8">
          <Title level={2} className="text-3xl font-bold text-gray-900 mb-2">
            App Configuration
          </Title>
          <p className="text-sm text-gray-600">
            Manage application layout, forms, modals, and other UI configurations for your organization.
          </p>
        </div>

        <div className="bg-white shadow rounded-lg">
          <div className="p-6">
            <AppConfigurationSettings applicationFilter="admin" defaultApplication="admin" />
          </div>
        </div>
    </div>
  )
}

export default AppConfigurationPage